module.exports = __webpack_public_path__ + "static/img/Y-merkki_logo_vaaka_suomi_musta_rgb.6fdc214.png";